import { mapUserFromDTO } from '@entities/user/api/mappers'
import type { AdCampaign, AdCampaignDTO } from '../model/types'
import type { CreateAdCampaignArgs, CreateAdCampaignArgsDTO } from './types'

export const mapAdCampaignFromDTO = ({
    id,
    name,
    type,
    partners_count,
    resources_count,
    spent,
    creator
}: AdCampaignDTO): AdCampaign => ({
    id,
    name,
    type,
    partnersCount: partners_count,
    resourcesCount: resources_count,
    spent,
    creator: mapUserFromDTO(creator)
})

export const mapAdCampaignToDTO = ({ name, type, channel }: CreateAdCampaignArgs): CreateAdCampaignArgsDTO => ({
    name,
    type,
    channel
})
